import { render } from "./ManagementProject.vue?vue&type=template&id=0c0ace03&scoped=true"
import script from "./ManagementProject.vue?vue&type=script&lang=js"
export * from "./ManagementProject.vue?vue&type=script&lang=js"

import "./ManagementProject.vue?vue&type=style&index=0&id=0c0ace03&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0ace03"]])

export default __exports__